import script from "./UiClickOutside.vue?vue&type=script&lang=js"
export * from "./UiClickOutside.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__